import { render } from "./NewEmailTemplate.vue?vue&type=template&id=3b9fcd9a"
import script from "./NewEmailTemplate.vue?vue&type=script&lang=js"
export * from "./NewEmailTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__